import React from "react";
import classNames from "classnames";
import { Link, withRouter, RouteComponentProps } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import createStyles from "@material-ui/core/styles/createStyles";
import { Theme } from "@material-ui/core/styles/createMuiTheme";
import { appBarStyles } from "./appBarTheme";

const styles = (theme: Theme) => createStyles(appBarStyles(theme));

export interface AppBarNavChipItem {
  href: string;
  label: string;
  Icon: React.ComponentType<{ fontSize?: "small" | "inherit" | "default" | "large" }>;
}

interface Props extends RouteComponentProps {
  classes: {
    navChip: string;
    navChipActive: string;
    navChipIcon: string;
  };
  item: AppBarNavChipItem;
}

const isNavActive = (pathname: string, href: string) => {
  const hrefPath = href.split("?")[0];
  return (
    pathname === hrefPath ||
    (hrefPath !== "/" && pathname.startsWith(`${hrefPath}/`))
  );
};

const AppBarNavChip = ({ classes, item, location }: Props) => {
  const { href, label, Icon } = item;
  const active = isNavActive(location.pathname, href);

  return (
    <Link
      to={href}
      className={classNames(classes.navChip, {
        [classes.navChipActive]: active,
      })}
    >
      <span className={classes.navChipIcon}>
        <Icon fontSize="small" />
      </span>
      {label}
    </Link>
  );
};

export default withStyles(styles)(withRouter(AppBarNavChip));
